import React, { useState } from "react";
import { useQuery } from "react-query";
import { Container } from "../../lib";
import { getFanReportLogAllMatch } from "../../../../api/report/reportApi";
import AttendeAllLogTable from "./AttendeAllLogTable";
import { KTIcon } from "../../../../../_metronic/helpers";

interface UserInfo {
  f_name: string;
  l_name: string;
  mobile: string;
  national_code: string;
}

const ReportAttendeLogPage: React.FC = () => {
  const [nationalCode, setNationalCode] = useState<string>("");
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    numberInPage: 10
  });

  const { data, isLoading, isError, refetch } = useQuery(
    ["fansReportLog", queryParams.page, queryParams.numberInPage, nationalCode],
    () => getFanReportLogAllMatch(nationalCode, {
      page: queryParams.page,
      numberInPage: queryParams.numberInPage
    }),
    {
      enabled: isSubmitted && !!nationalCode,
      onSuccess: (data) => {
        if (data?.userLogs?.[0]?.ticket?.user) {
          setUserInfo({
            f_name: data.userLogs[0].ticket.user.f_name || '',
            l_name: data.userLogs[0].ticket.user.l_name || '',
            mobile: data.userLogs[0].ticket.user.mobile || '',
            national_code: data.userLogs[0].ticket.user.national_code || nationalCode
          });
        }
      }
    }
  );

  const handleNationalCodeSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (nationalCode) {
      setIsSubmitted(true);
    }
  };

  const handlePageChange = (newPage: number) => {
    setQueryParams(prev => ({
      ...prev,
      page: newPage
    }));
  };

  const handleClear = () => {
    setNationalCode("");
    setIsSubmitted(false);
    setUserInfo(null);
  };
  return (
    <Container className="bg-white p-0 mt-10">
      <div className="d-flex align-items-center justify-content-between table-header">
        <div className="d-flex align-items-center gap-4">
          <h3>گزارش فعالیت‌های هوادار</h3>
        </div>
      </div>

      <div className="p-4">
        <form onSubmit={handleNationalCodeSubmit} className="d-flex gap-2 mb-4">
          <div className="d-flex gap-2">
            <input
              type="text"
              className="form-control"
              placeholder="کد ملی را وارد کنید..."
              value={nationalCode}
              onChange={(e) => setNationalCode(e.target.value)}
              pattern="[0-9]{10}"
              maxLength={10}
              required
            />
            <button
              type="submit"
              className="btn btn-primary"
            >
              بررسی
            </button>
            <button
              type="button"
              className="btn btn-secondary "
              onClick={handleClear}
            >
              <KTIcon iconName="arrow-right" className="fs-2" />
            </button>
          </div>
        </form>

        {isSubmitted && (
          <>
            {isLoading ? (
              <div className="text-center p-4">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">در حال بارگذاری...</span>
                </div>
              </div>
            ) : isError ? (
              <div className="alert alert-danger m-4">
                خطا در دریافت اطلاعات. لطفا دوباره تلاش کنید.
              </div>
            ) : !data?.userLogs?.length ? (
              <div className="alert alert-info m-4">
                {`اطلاعاتی برای کد ملی ${nationalCode} یافت نشد`}
              </div>
            ) : (
              <AttendeAllLogTable
                data={data}
                queryString={queryParams}
                nationalCode={nationalCode}
                setQueryString={handlePageChange}
                refetch={refetch}
              />
            )}
          </>
        )}
      </div>
    </Container>
  );
};

export default ReportAttendeLogPage;